module.exports = __webpack_public_path__ + "static/img/soft_5.94912e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/soft_5.png
// module id = VhAT
// module chunks = 0